import {PASS_WINDOW_HOURS} from './passTiers.js';
export const passKey = p => p ? `${p.norad_id}:${p.start}` : null;
export function tonightPasses(passes, now = Date.now()) {
  return (passes || []).filter(p => p.visibility_tier > 0 && Date.parse(p.end) > now && Date.parse(p.start) < now + PASS_WINDOW_HOURS * 3600000)
    .sort((a,b)=>Date.parse(a.start)-Date.parse(b.start));
}
export function selectTonightPass(passes, focused) {
  return passes.find(p=>passKey(p)===passKey(focused)) || passes[0] || null;
}

export function skyTargets(data,mode) {
  return mode==='planet' ? (data.bodies||[]).filter(b=>['planet','moon'].includes(b.type)&&b.above_horizon&&b.elevation_deg>5).sort((a,b)=>b.elevation_deg-a.elevation_deg).slice(0,8) : (data.targets||[]).slice(0,8);
}
